import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { loginNavigationExtras } from '../../auth/safe-return-url';
import { LoginService } from '../../auth/login.service';
import { evaluateTwoFactorAccess } from './two-factor.guard';

export const AuthGuard: CanActivateFn = (_route, state) => {
  const loginService = inject(LoginService);
  const router = inject(Router);

  return loginService.ensureSession().pipe(
    map(ok => {
      if (!ok) {
        void router.navigate(['/login'], loginNavigationExtras(state.url));
        return false;
      }
      // Do not call TwoFactorGuard here — inject() is invalid inside map().
      return evaluateTwoFactorAccess(loginService, router, state);
    })
  );
};
